import React from 'react';
import DocumentTitle from 'react-document-title';

import {Separator} from 'src/components/separator';
import {TabId, TabItem} from 'src/modules/admin/admin-tabs-panel/typedefs';

import {Group, Item} from '@pb/kit-component-group';
import {Tab, Tabs} from '@pb/kit-component-tabs-v2';

import {pageHeadline, pageHeadlineTitle} from './page-headline.module.styl';

type Props = {
    tabs: TabItem[],
    activeTab: TabId,
    onChangeTab: (tab: string) => void,
};

export const AdminTabsPanelView = (props: Props) => {
    const {
        tabs,
        activeTab,
        onChangeTab,
    } = props;

    return (
        <>
            <DocumentTitle title="Admin"/>
            <Group direction="v" gap="none">
                <Group className={pageHeadline} style={{width: '100%'}}>
                    <Item className={pageHeadlineTitle} style={{width: '100%'}}>Admin</Item>
                </Group>
                <Tabs value={activeTab} onChange={onChangeTab}>
                    {tabs.map(tab => (
                        <Tab key={tab.tabId} caption={tab.caption} value={tab.tabId}/>
                    ))}
                </Tabs>
                <Separator/>
            </Group>
        </>
    );
};
